import type { AnchorHTMLAttributes } from 'react'

import { appSelectors } from '@appStore/reducers/app'
import { connectorApi } from 'api/connector/api'
import { Link, useNavigate } from 'react-router-dom'
import { notifyError } from 'shared/errors'
import { useAppSelector } from 'shared/hooks'

type Props = Pick<
	AnchorHTMLAttributes<HTMLAnchorElement>,
	'children' | 'className' | 'href' | 'id'
>

export function PersonLink({ href = '', id, ...props }: Props) {
	const userId = useAppSelector(
		state => appSelectors.appProfile(state)?.personaId ?? ''
	)

	const isCurrent = userId === id

	return isCurrent ? (
		<Link {...props} to={href} />
	) : (
		<WithLogging href={href} id={id} {...props} />
	)
}

function WithLogging({ href = '', id = '', ...props }: Props) {
	const navigate = useNavigate()

	const [signIn] = connectorApi.useSignInUnderTeamMemberMutation()

	async function wrappedSignIn() {
		try {
			await signIn(id)
			navigate(href)
		} catch (error) {
			notifyError(error)
		}
	}
	return <button onClick={wrappedSignIn} type='button' {...props} />
}
